module.exports = __webpack_public_path__ + "media/video.1da778ef.mp4";